import React, { useState } from "react";

export const GlobalState = React.createContext();

const initialState = {};

export const GlobalContext = ({ children }) => {
  const [state, setState] = useState(initialState);

  const setIsInvitation = (isInvitation) => {
    setState((prev) => ({ ...prev, isInvitation }));
  };

  const setPasswordToken = (passwordToken) => {
    setState((prev) => ({ ...prev, passwordToken }));
  };

  return (
    <GlobalState.Provider
      value={{
        state,
        setIsInvitation,
        setPasswordToken,
      }}
    >
      {children}
    </GlobalState.Provider>
  );
};
